export default __webpack_public_path__ + "512bef9ef21fbc563c19702e291f8518.png";